import { styled } from '@mui/material'

export const Brand = styled('span')`
  cursor: pointer;
  margin: 0;
`

export const BrandLogo = styled('img')`
  height: 70px;
  margin: 0 57px 0 0;
  pointer-events: none;
  user-select: none;

  ${props => props.theme.breakpoints.between('sm', 'lg')} {
    height: 60px;
  }

  ${props => props.theme.breakpoints.down('sm')} {
    height: 50px;
  }
`

export const Content = styled('div')`
  width: 100%;
  flex-grow: 1;
  display: flex;
  ${props => props.theme.breakpoints.down('sm')} {
    flex-direction: column;
  }
`

export const ContentMiddle = styled('div')``

export const DesktopStep = styled('div')`
  display: grid;
  grid-template-columns: auto 32px;
  grid-column-gap: 19px;
  justify-content: flex-end;
  padding: 57px 0 0;

  &:first-of-type {
    padding: 0;
  }
`

export const DesktopStepInfoSubtitle = styled('h2')`
  color: ${props => props.theme.palette.custom.baliHai};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 15px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: initial;
  margin: 2px 0 0;
  text-align: right;
  white-space: nowrap;
  width: 100%;
`

export const DesktopStepInfoTitle = styled('h1')`
  color: ${props => props.theme.palette.custom.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 15px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: initial;
  margin: 0;
  text-align: right;
  width: 100%;
`

export const DesktopSteps = styled('div')`
  margin: 46px 89px 0 0;

  ${props => props.theme.breakpoints.between('sm', 'lg')} {
    margin: 30px 86px 0 0;
  }
`

export const DesktopStepsContent = styled('div')`
  display: table;
  height: auto;
  position: relative;
`

export const DesktopStepsLine = styled('span')`
  background-color: ${props => props.theme.palette.custom.blueRibbon15};
  display: block;
  height: calc(100% - 10px);
  position: absolute;
  right: 15px;
  top: 0;
  width: 2px;
  z-index: -1;
`

export const Header = styled('section')`
  margin: 1rem 0 20px;
  height: auto;
  width: 100%;

  ${props => props.theme.breakpoints.down('sm')} {
    display: flex;
    justify-content: flex-start;
    margin: 25px 5px 0 0;
  }

  ${props => props.theme.breakpoints.only('xs')} {
    text-align: center;
  }
`

export const MobileStep = styled('div')`
  align-items: center;
  background-color: ${props => props.theme.palette.gray[90]};
  display: grid;
  grid-template-columns: 32px auto;
  grid-column-gap: 19px;
  height: 72px;
  margin: 10px -29px 33px;
  padding: 0 29px;
  width: auto;
`

export const MobileStepInfoSubtitle = styled('h2')`
  color: ${props => props.theme.palette.brand.black3};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 15px;
  letter-spacing: 0;
  line-height: initial;
  margin: 2px 0 0;
  text-align: left;
  white-space: nowrap;
  width: 100%;
`

export const MobileStepInfoTitle = styled('h1')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 15px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: initial;
  margin: 0;
  text-align: left;
  width: 100%;
`

export const Root = styled('div')`
  box-sizing: border-box;
  height: 100%;
  margin: auto;
  padding: 50px 10px;
  width: 100%;

  ${props => props.theme.breakpoints.only('xs')} {
    max-width: 540px;
    padding: 0 29px;
    text-align: center;
  }

  ${props => props.theme.breakpoints.only('sm')} {
    max-width: 720px;
  }

  ${props => props.theme.breakpoints.only('md')} {
    max-width: 960px;
  }

  ${props => props.theme.breakpoints.only('lg')} {
    max-width: 1140px;
  }

  ${props => props.theme.breakpoints.only('xl')} {
    max-width: 1140px;
  }
`

export const StepIcon = styled('div')`
  align-items: center;
  background-color: ${props => {
    if (props.status === 'active') {
      return props.theme.palette.green[50]
    }

    if (props.status === 'completed') {
      return props.theme.palette.custom.baliHai
    }

    return props.theme.palette.gray[90]
  }};
  border-radius: 50%;
  display: flex;
  height: 32px;
  justify-content: center;
  width: 32px;
`

export const StepInfo = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
`
